import fetchImageForCanvas from "./fetchImageForCanvas";

/**
 * Photo → 600×800 PNG Blob for the async clipboard.
 *
 * Callers pass the PROMISE straight into `new ClipboardItem({ "image/png": … })`
 * and call `navigator.clipboard.write()` synchronously — that keeps the write
 * inside the click's user activation. Chain `.then/.catch` on the write for the
 * toast: a failure here REJECTS, which rejects the write. (It used to hang
 * forever on a load error, and the call sites toasted "Image copied" anyway.)
 *
 * The bytes come from `fetchImageForCanvas` (CORS fetch, no-store, blob url),
 * never from a crossOrigin <img> — see that file for the cache trap this
 * avoids. Works for CloudFront urls, private signed urls and data: URIs.
 * The 600×800 stretch is unchanged from the original.
 */
const copyImageToClip = async (imgSrc) => {
  const img = await fetchImageForCanvas(imgSrc);

  const canvas = document.createElement("canvas");
  canvas.width = 600;
  canvas.height = 800;
  canvas.getContext("2d").drawImage(img, 0, 0, 600, 800);

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) resolve(blob);
      else reject(new Error("copyImageToClip: canvas.toBlob returned null"));
    }, "image/png");
  });
};

export default copyImageToClip;
